module.exports = __webpack_public_path__ + "img/telegram.8967c418.png";